import React, {useMemo} from 'react';
import moment from 'moment';
import { Select, Space, Typography, Input, Popover } from 'antd';
import { HelpIcon } from 'components/Icons';
import AuthorisedContainer from 'components/AuthorisedContainer';
import { PermissionSetMap } from 'constants/RBACConstants';
const {Text} = Typography;

const DURATION_OPTIONS = [
    {label: "Minutes", value: 'MINUTES'},
    {label: "Hours", value: 'HOURS'},
    {label: "Days", value: 'DAYS'}
];

const TOOL_TIP_TOOL_INACTIVE_STATUS = 'If scan is not coming from the tool as per selected time, tool status will be changed to inactive.';

export const validateInactiveDuration = ({toolFrequencyInterval,markInactiveAfter,frequencyUnit}) => {
    const validationObject = {
        isError: false,
        errorMessage: null,
    };
    if(!toolFrequencyInterval || (!markInactiveAfter && !frequencyUnit)){
        return validationObject;
    }

    if(markInactiveAfter && frequencyUnit){
        const maxLimits = {
            'DAYS': 365,
            'HOURS': 8760,
            'MINUTES': 525600
        };

        const maxLimit = maxLimits[frequencyUnit];
        if(markInactiveAfter > maxLimit){
            validationObject.isError = true;
            validationObject.errorMessage = 'The maximum allowed limit is 365 days. Please contact ArmorCode Support if you wish to customise this further.';
            return validationObject;
        }
    }

    const inActiveAfterDurationInMilis = moment.duration(markInactiveAfter,frequencyUnit).asMilliseconds();
    if(inActiveAfterDurationInMilis < toolFrequencyInterval){
        validationObject.isError = true;
        validationObject.errorMessage = 'Value configured for Tool Inactive Status should be greater than that of the frequency for checking scans';
    }
    return validationObject;
}

const ErrorMessage = ({message}) => {
    if(typeof message !== 'string' || message.trim() === ''){
        return null;
    }
    return(
        <Text type='danger'>{message}</Text>
    );
}

const MarkInactiveAfter = (props) => {
    const {
        frequencyUnit,
        markInactiveAfter,
        handleChangeMarkInactiveAfter,
        setFrequencyUnit,
        isError,
        errorMessage,
    } = props;
    const wrapperClass = isError === true ? 'ant-form-item-has-error' : ''
    const periodSelectBox = useMemo(()=>(
        <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
            <Select 
            placeholder="Period" 
            options={DURATION_OPTIONS} 
            onChange={setFrequencyUnit} 
            style={{width:100}} 
            value={frequencyUnit}
        />
        </AuthorisedContainer>
    ),[frequencyUnit,setFrequencyUnit]);
    return(
        <Space className='m-t-sm' direction="vertical">
            <Typography.Text>
                Tool Inactive Status &nbsp;
                <Popover content={TOOL_TIP_TOOL_INACTIVE_STATUS} placement="top" ><HelpIcon /></Popover>
            </Typography.Text>
            <Space className={wrapperClass} direction="horizontal">
                <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                    <Input 
                        type='number' 
                        onChange={handleChangeMarkInactiveAfter} 
                        placeholder='Duration' 
                        style={{width:200}} 
                        value={markInactiveAfter} 
                        addonAfter={periodSelectBox} 
                    />
                </AuthorisedContainer>
            </Space>
            <ErrorMessage message={errorMessage} />
        </Space>
    );
}

export default MarkInactiveAfter;